import * as React from 'react'
import * as ThemeUI from 'theme-ui'
import * as PropTypes from 'prop-types'

function SvgIcon(props) {
  return (
    <ThemeUI.Box
      as="svg"
      width="1em"
      height="1em"
      viewBox="0 0 44 44"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      sx={{
        mt: '-0.105em',
        mb: '-0.145em',
        height: '1.25em',
        width: '1.25em',
        verticalAlign: '-0.185em',
        ...props.sx,
      }}
    >
      {props.children}
    </ThemeUI.Box>
  )
}
SvgIcon.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object,
}
export function Spinner() {
  return (
    <SvgIcon>
      <g fill="none" fillRule="evenodd" strokeWidth="2" stroke="currentColor">
        <circle cx="22" cy="22" r="1">
          <animate
            attributeName="r"
            begin="0s"
            dur="1.8s"
            values="1; 20"
            calcMode="spline"
            keyTimes="0; 1"
            keySplines="0.165, 0.84, 0.44, 1"
            repeatCount="indefinite"
          />
          <animate
            attributeName="stroke-opacity"
            begin="0s"
            dur="1.8s"
            values="1; 0"
            calcMode="spline"
            keyTimes="0; 1"
            keySplines="0.3, 0.61, 0.355, 1"
            repeatCount="indefinite"
          />
        </circle>
        <circle cx="22" cy="22" r="1">
          <animate
            attributeName="r"
            begin="-0.9s"
            dur="1.8s"
            values="1; 20"
            calcMode="spline"
            keyTimes="0; 1"
            keySplines="0.165, 0.84, 0.44, 1"
            repeatCount="indefinite"
          />
          <animate
            attributeName="stroke-opacity"
            begin="-0.9s"
            dur="1.8s"
            values="1; 0"
            calcMode="spline"
            keyTimes="0; 1"
            keySplines="0.3, 0.61, 0.355, 1"
            repeatCount="indefinite"
          />
        </circle>
      </g>
    </SvgIcon>
  )
}

export function ArrowForward() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="currentColor"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
    </svg>
  )
}

export function Rocket() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2766 5.46626L12.2766 5.46626L8.26827 9.47494L8.26827 9.47495C7.41542 10.3279 6.98899 10.7543 6.76104 11.2144C6.32734 12.0896 6.32736 13.1173 6.7611 13.9925C6.78322 14.0372 6.80721 14.0815 6.83327 14.1259C7.16666 14.6941 7.33336 14.9782 7.71425 15.027C8.09514 15.0758 8.38547 14.7855 8.96613 14.2048L9.418 13.753C9.64708 13.5239 10.0185 13.5239 10.2476 13.753C10.4767 13.982 10.4767 14.3535 10.2476 14.5825L9.79572 15.0344C9.21504 15.6151 8.9247 15.9054 8.97351 16.2863C9.02232 16.6672 9.30644 16.8339 9.87466 17.1672C9.91903 17.1932 9.96329 17.2172 10.0079 17.2393C10.8832 17.673 11.9109 17.673 12.7862 17.2392C13.2462 17.0112 13.6727 16.5848 14.5256 15.7318L14.5256 15.7318L18.5339 11.7232C19.0749 11.1821 19.3454 10.9116 19.5389 10.5958C19.7104 10.3159 19.8368 10.0108 19.9134 9.69157C19.9999 9.33153 19.9999 8.94895 19.9999 8.18378L19.9999 7.75425C19.9999 6.44014 19.9999 5.78308 19.7441 5.28116C19.5192 4.83965 19.1602 4.4807 18.7187 4.25574C18.2168 4 17.5597 4 16.2456 4H15.8163C15.0511 4 14.6684 4 14.3084 4.08645C13.9891 4.1631 13.6839 4.28952 13.404 4.46107C13.0883 4.65456 12.8177 4.92512 12.2766 5.46626ZM17 9.0205C17 10.1352 16.0964 11.0388 14.9817 11.0388C13.867 11.0388 12.9634 10.1352 12.9634 9.02051C12.9634 7.90582 13.867 7.00219 14.9817 7.00219C16.0964 7.00219 17 7.90582 17 9.0205ZM7.06332 9.1164C6.797 9.38275 6.66385 9.51592 6.50739 9.57548C6.36948 9.62798 6.21953 9.64039 6.07486 9.61128C5.91074 9.57826 5.75749 9.4688 5.45101 9.24987L5.451 9.24987L4.77829 8.76934C4.36473 8.47392 4.15794 8.32622 4.07112 8.13677C3.99493 7.97053 3.9794 7.78284 4.02723 7.60633C4.08173 7.4052 4.26142 7.22551 4.62081 6.86614L4.89295 6.594C5.41239 6.07457 5.67211 5.81486 5.97946 5.65071C6.25155 5.50539 6.54962 5.41515 6.85662 5.38514C7.2034 5.35125 7.56356 5.42328 8.28388 5.56736L9.07764 5.72612C9.45003 5.8006 9.63622 5.83784 9.72334 5.93602C9.79923 6.02155 9.83388 6.136 9.81819 6.24926C9.80017 6.37927 9.66591 6.51355 9.39739 6.78209L7.06332 9.1164ZM17.4071 19.1083C17.9267 18.5888 18.1864 18.3291 18.3506 18.0217C18.4959 17.7495 18.5862 17.4514 18.6161 17.1443C18.65 16.7975 18.5779 16.4373 18.4337 15.7169L18.2748 14.923C18.2003 14.5506 18.163 14.3645 18.0648 14.2774C17.9793 14.2015 17.8648 14.1668 17.7516 14.1825C17.6216 14.2006 17.4873 14.3349 17.2188 14.6034L14.8848 16.9377L14.8848 16.9378C14.6185 17.2041 14.4854 17.3372 14.4259 17.4937C14.3734 17.6316 14.361 17.7815 14.3901 17.9262C14.4231 18.0903 14.5325 18.2435 14.7514 18.5499L15.232 19.2227C15.5274 19.6363 15.6751 19.8431 15.8646 19.9299C16.0308 20.0061 16.2185 20.0217 16.395 19.9738C16.5962 19.9193 16.7758 19.7396 17.1352 19.3803L17.4071 19.1083Z"
      />
    </svg>
  )
}

export function Account() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.90075 7.65067C7.90075 5.63446 9.53521 4 11.5514 4C13.5676 4 15.2021 5.63446 15.2021 7.65067C15.2021 9.66688 13.5676 11.3013 11.5514 11.3013C9.53521 11.3013 7.90075 9.66688 7.90075 7.65067ZM9.23092 12.702C6.89432 12.702 5.00012 14.5962 5.00012 16.9328C5.00012 18.6286 6.37485 20.0033 8.07066 20.0033H15.0323C16.7281 20.0033 18.1028 18.6286 18.1028 16.9328C18.1028 14.5962 16.2086 12.702 13.872 12.702H9.23092Z"
      />
    </svg>
  )
}

export function Present() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6028 6.56291C15.6028 5.97588 15.1269 5.5 14.5399 5.5H14.4817C13.9867 5.5 13.5502 5.82474 13.4079 6.29895L13.1226 7.25H15.3509C15.5081 7.06472 15.6028 6.82488 15.6028 6.56291ZM17.0097 7.25C17.0704 7.03133 17.1028 6.80091 17.1028 6.56291C17.1028 5.14745 15.9554 4 14.5399 4H14.4817C13.3577 4 12.363 4.71593 12.0018 5.77254C11.6406 4.71593 10.6458 4 9.52183 4H9.46365C8.04819 4 6.90074 5.14745 6.90074 6.56291C6.90074 6.80091 6.93318 7.03133 6.99388 7.25H6.00012C5.03362 7.25 4.25012 8.0335 4.25012 9C4.25012 9.9665 5.03362 10.75 6.00012 10.75H18.0001C18.9666 10.75 19.7501 9.9665 19.7501 9C19.7501 8.0335 18.9666 7.25 18.0001 7.25H17.0097ZM8.65264 7.25C8.49551 7.06472 8.40074 6.82488 8.40074 6.56291C8.40074 5.97588 8.87662 5.5 9.46365 5.5H9.52183C10.0169 5.5 10.4534 5.82474 10.5956 6.29895L10.881 7.25H8.65264ZM7.62064 12.2499L7.71441 12.25H16.2858L16.3796 12.2499C16.7617 12.2491 17.127 12.2484 17.4442 12.3594C18.0043 12.5554 18.4447 12.9958 18.6407 13.556C18.7517 13.8731 18.751 14.2384 18.7502 14.6205L18.7501 14.7143L18.7502 14.8633C18.7506 15.9156 18.7509 16.6349 18.5397 17.2385C18.1628 18.3157 17.3158 19.1626 16.2387 19.5396C15.635 19.7508 14.9157 19.7505 13.8634 19.75L13.7144 19.75H10.2858L10.1369 19.75C9.08452 19.7505 8.36523 19.7508 7.76158 19.5396C6.6844 19.1626 5.83748 18.3157 5.46056 17.2385C5.24933 16.6349 5.24964 15.9156 5.25008 14.8632L5.25012 14.7143L5.25 14.6205C5.24927 14.2384 5.24856 13.8731 5.35955 13.556C5.55555 12.9958 5.99595 12.5554 6.55608 12.3594C6.87327 12.2484 7.23852 12.2491 7.62064 12.2499Z"
      />
    </svg>
  )
}

export function Support() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0006 4C7.58203 4 4.00006 7.58197 4.00006 12.0006C4.00006 13.1986 4.26411 14.337 4.7376 15.3591L5.41784 15.044L4.7376 15.3591C5.10179 16.1453 5.26606 16.5043 5.12011 17.0122L5.83788 17.2184L5.12011 17.0122C5.092 17.11 5.05001 17.201 4.98306 17.3462C4.96185 17.3922 4.93815 17.4436 4.91159 17.5023C4.81934 17.7064 4.68976 18.0088 4.66141 18.3541C4.58276 19.3117 5.42611 20.0877 6.37393 19.9298L6.25358 19.2074L6.37393 19.9298C6.87137 19.8469 7.3056 19.622 7.5937 19.4727C7.66003 19.4384 7.71861 19.408 7.76844 19.3843C8.05305 19.2491 8.26107 19.1905 8.58468 19.2666L8.58469 19.2666C8.5852 19.2667 8.60426 19.2716 8.65454 19.2877C8.70198 19.303 8.76509 19.3242 8.84804 19.353C9.01416 19.4107 9.24322 19.4926 9.55564 19.6043L9.79044 18.948L9.55564 19.6043C10.3046 19.8723 11.0999 20.0011 12.0006 20.0011C16.4192 20.0011 20.0012 16.4191 20.0012 12.0006C20.0012 7.58197 16.4192 4 12.0006 4ZM12.0001 9C11.4478 9 11.0001 9.44772 11.0001 10V10.5C11.0001 11.0523 10.5523 11.5 10.0001 11.5C9.44778 11.5 9.00006 11.0523 9.00006 10.5V10C9.00006 8.34315 10.3432 7 12.0001 7C13.6569 7 15.0001 8.34315 15.0001 10V10.1213C15.0001 10.9491 14.6712 11.7431 14.0858 12.3284L12.7072 13.7071C12.3166 14.0976 11.6835 14.0976 11.293 13.7071C10.9024 13.3166 10.9024 12.6834 11.293 12.2929L12.6716 10.9142C12.8819 10.7039 13.0001 10.4187 13.0001 10.1213V10C13.0001 9.44772 12.5523 9 12.0001 9ZM12.0001 17C12.5523 17 13.0001 16.5523 13.0001 16C13.0001 15.4477 12.5523 15 12.0001 15C11.4478 15 11.0001 15.4477 11.0001 16C11.0001 16.5523 11.4478 17 12.0001 17Z"
      />
    </svg>
  )
}

export function Cards() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5367 11.6251L16.5173 6.00094C16.5135 4.89638 15.615 4.00403 14.5105 4.00782L13.3904 4.01167L16.5367 11.6251ZM3.95784 7.08474C2.93926 7.51201 2.4599 8.6841 2.88716 9.70269L6.6972 18.7856C7.12446 19.8042 8.29656 20.2836 9.31515 19.8563L14.6417 17.622C15.6603 17.1947 16.1397 16.0226 15.7124 15.004L11.9024 5.92106C11.4751 4.90248 10.303 4.42312 9.28445 4.85038L3.95784 7.08474ZM8.50666 9.38718C8.20932 9.18997 7.80705 9.35871 7.73938 9.70903L7.10915 12.9715C7.07087 13.1697 7.1555 13.3714 7.32372 13.483L10.0928 15.3195C10.3902 15.5167 10.7924 15.348 10.8601 14.9977L11.4903 11.7352C11.5286 11.537 11.444 11.3353 11.2758 11.2237L8.50666 9.38718ZM20.5907 8.46531L18.3731 13.6342L18.5117 5.39711L19.5412 5.83879C20.5563 6.27428 21.0262 7.45022 20.5907 8.46531Z"
      />
    </svg>
  )
}

export function BasketBall() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0741 5.79212C15.7226 4.68953 14.0471 4.06006 12.304 4C12.4734 4.99994 12.4299 6.02437 12.1764 7.00636C11.9228 7.98835 11.4649 8.90578 10.8326 9.69871L12.0001 10.8662L17.0741 5.79212ZM8.55293 9.68668L5.79218 6.92593C4.90566 8.01233 4.3215 9.31342 4.09869 10.6978C4.87055 10.8506 5.66589 10.8395 6.4332 10.6653C7.2005 10.4911 7.92267 10.1577 8.55293 9.68668ZM18.2079 6.92593L13.1339 12L14.3014 13.1675C15.0944 12.5353 16.0118 12.0775 16.9938 11.8239C17.9757 11.5704 19.0001 11.5268 20.0001 11.6961C19.94 9.95293 19.3105 8.27743 18.2079 6.92593ZM19.9014 13.3022C19.1296 13.1494 18.3342 13.1605 17.5669 13.3347C16.7996 13.5089 16.0775 13.8423 15.4472 14.3133L18.2079 17.0741C19.0949 15.988 19.6791 14.6867 19.9014 13.3022ZM9.68674 8.55287C10.1578 7.92261 10.4912 7.20044 10.6654 6.43313C10.8395 5.66583 10.8506 4.87049 10.6979 4.09863C9.31337 4.32107 8.01219 4.90527 6.92599 5.79212L9.68674 8.55287ZM13.3023 19.9014C14.6866 19.6789 15.9877 19.095 17.0741 18.2087L14.3134 15.4479C13.8423 16.078 13.5088 16.8 13.3346 17.5672C13.1605 18.3344 13.1494 19.1296 13.3023 19.9014ZM12.0001 13.1338L6.92599 18.2079C8.27749 19.3105 9.95299 19.9399 11.6962 20C11.5267 19.0001 11.5702 17.9756 11.8238 16.9936C12.0773 16.0117 12.5352 15.0942 13.1675 14.3013L12.0001 13.1338ZM5.79218 17.0741L10.8663 12L9.69877 10.8325C8.90577 11.4647 7.98833 11.9225 7.00636 12.1761C6.0244 12.4296 5 12.4732 4.00006 12.3039C4.06012 14.0471 4.6896 15.7226 5.79218 17.0741Z"
      />
    </svg>
  )
}

export function ExpandMore() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.3em"
      height="1.3em"
      viewBox="0 0 24 24"
    >
      <path
        d="M12 15L6 9"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 15L18 9"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}
export function Search() {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
    >
      <path
        d="M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z"
        fill="currentColor"
      />
    </svg>
  )
}
Search.propTypes = {
  sx: PropTypes.object,
}
export function Done() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
        fill="currentColor"
      />
    </svg>
  )
}
export function CheckCircle() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
      />
    </svg>
  )
}

export function Inventory() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.25em"
      height="1.25em"
      viewBox="0 0 24 24"
    >
      <path
        d="M18.1818 4.31818H16.8636V3.65909C16.8636 3.48429 16.7942 3.31665 16.6706 3.19304C16.547 3.06944 16.3793 3 16.2045 3C16.0297 3 15.8621 3.06944 15.7385 3.19304C15.6149 3.31665 15.5455 3.48429 15.5455 3.65909V4.31818H12.9091V3.65909C12.9091 3.48429 12.8397 3.31665 12.716 3.19304C12.5924 3.06944 12.4248 3 12.25 3C12.0752 3 11.9076 3.06944 11.784 3.19304C11.6603 3.31665 11.5909 3.48429 11.5909 3.65909V4.31818H8.95455V3.65909C8.95455 3.48429 8.88511 3.31665 8.7615 3.19304C8.6379 3.06944 8.47026 3 8.29545 3C8.12065 3 7.95301 3.06944 7.82941 3.19304C7.7058 3.31665 7.63636 3.48429 7.63636 3.65909V4.31818H6.31818C5.96858 4.31818 5.63329 4.45706 5.38609 4.70427C5.13888 4.95148 5 5.28676 5 5.63636V18.1591C5 18.8583 5.27776 19.5289 5.77217 20.0233C6.26659 20.5177 6.93716 20.7955 7.63636 20.7955H16.8636C17.5628 20.7955 18.2334 20.5177 18.7278 20.0233C19.2222 19.5289 19.5 18.8583 19.5 18.1591V5.63636C19.5 5.28676 19.3611 4.95148 19.1139 4.70427C18.8667 4.45706 18.5314 4.31818 18.1818 4.31818V4.31818ZM14.8864 15.5227H9.61364C9.43883 15.5227 9.27119 15.4533 9.14759 15.3297C9.02399 15.2061 8.95455 15.0384 8.95455 14.8636C8.95455 14.6888 9.02399 14.5212 9.14759 14.3976C9.27119 14.274 9.43883 14.2045 9.61364 14.2045H14.8864C15.0612 14.2045 15.2288 14.274 15.3524 14.3976C15.476 14.5212 15.5455 14.6888 15.5455 14.8636C15.5455 15.0384 15.476 15.2061 15.3524 15.3297C15.2288 15.4533 15.0612 15.5227 14.8864 15.5227ZM14.8864 12.8864H9.61364C9.43883 12.8864 9.27119 12.8169 9.14759 12.6933C9.02399 12.5697 8.95455 12.4021 8.95455 12.2273C8.95455 12.0525 9.02399 11.8848 9.14759 11.7612C9.27119 11.6376 9.43883 11.5682 9.61364 11.5682H14.8864C15.0612 11.5682 15.2288 11.6376 15.3524 11.7612C15.476 11.8848 15.5455 12.0525 15.5455 12.2273C15.5455 12.4021 15.476 12.5697 15.3524 12.6933C15.2288 12.8169 15.0612 12.8864 14.8864 12.8864Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function Logout() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.25em"
      height="1.25em"
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.95 4L9.91957 4C9.38541 3.99999 8.93956 3.99998 8.57533 4.02974C8.19545 4.06078 7.83879 4.12789 7.50153 4.29973C6.98408 4.56338 6.56338 4.98408 6.29973 5.50153C6.12789 5.83879 6.06078 6.19545 6.02974 6.57533C5.99998 6.93956 5.99999 7.38541 6 7.91956L6 7.95L6 16.0533L6 16.0837C5.99999 16.6179 5.99998 17.0637 6.02974 17.428C6.06078 17.8078 6.12789 18.1645 6.29973 18.5018C6.56338 19.0192 6.98408 19.4399 7.50153 19.7036C7.83879 19.8754 8.19545 19.9425 8.57533 19.9735C8.93956 20.0033 9.3854 20.0033 9.91955 20.0033H9.95H12.252H12.2824C12.8166 20.0033 13.2624 20.0033 13.6266 19.9735C14.0065 19.9425 14.3632 19.8754 14.7004 19.7036C15.2179 19.4399 15.6386 19.0192 15.9022 18.5018C16.0741 18.1645 16.1412 17.8078 16.1722 17.428C16.202 17.0637 16.202 16.6179 16.202 16.0838V16.0837V16.0533L16.202 7.95V7.91955V7.91951C16.202 7.38538 16.202 6.93955 16.1722 6.57533C16.1412 6.19545 16.0741 5.83879 15.9022 5.50153C15.6386 4.98408 15.2179 4.56338 14.7004 4.29973C14.3632 4.12789 14.0065 4.06078 13.6266 4.02974C13.2624 3.99998 12.8166 3.99999 12.2824 4L12.252 4L9.95 4ZM17.6457 8.39382C18.0362 8.00329 18.6694 8.00329 19.0599 8.39382L21.9605 11.2945C22.3511 11.685 22.3511 12.3182 21.9605 12.7087L19.0599 15.6093C18.6694 15.9999 18.0362 15.9999 17.6457 15.6093C17.2551 15.2188 17.2551 14.5857 17.6457 14.1951L18.8392 13.0016L11.101 13.0016C10.5488 13.0016 10.101 12.5539 10.101 12.0016C10.101 11.4493 10.5488 11.0016 11.101 11.0016L18.8392 11.0016L17.6457 9.80803C17.2551 9.41751 17.2551 8.78434 17.6457 8.39382Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function Error() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
      />
    </svg>
  )
}
export function Close() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 1.79988L16.2001 0L9 7.20012L1.79988 0L0 1.79988L7.20012 9L0 16.2001L1.79988 18L9 10.7999L16.2001 18L18 16.2001L10.7999 9L18 1.79988Z"
        fill="currentColor"
      />
    </svg>
  )
}
export function ShowPassword() {
  return (
    <svg
      width="22"
      height="15"
      viewBox="0 0 22 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 0C6 0 1.73 3.11 0 7.5C1.73 11.89 6 15 11 15C16 15 20.27 11.89 22 7.5C20.27 3.11 16 0 11 0ZM11 12.5C8.24 12.5 6 10.26 6 7.5C6 4.74 8.24 2.5 11 2.5C13.76 2.5 16 4.74 16 7.5C16 10.26 13.76 12.5 11 12.5ZM11 4.5C9.34 4.5 8 5.84 8 7.5C8 9.16 9.34 10.5 11 10.5C12.66 10.5 14 9.16 14 7.5C14 5.84 12.66 4.5 11 4.5Z"
        fill="#A0A0A0"
      />
    </svg>
  )
}
HamburgerMenu.propTypes = {
  onClick: PropTypes.func,
}
export function HamburgerMenu(props) {
  return (
    <ThemeUI.IconButton
      sx={{
        'p': '0px',
        'color': 'primary',
        '&:hover': {
          color: 'primary-hover',
        },
      }}
      onClick={props.onClick}
    >
      <svg
        width="20"
        height="15"
        viewBox="0 0 20 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 2.5V0H20V2.5H0ZM0 8.75H20V6.25H0V8.75ZM0 15H20V12.5H0V15Z"
          fill="currentColor"
        />
      </svg>
    </ThemeUI.IconButton>
  )
}
export function Chevron(props) {
  return (
    <SvgIcon
      sx={{
        transform: props.up ? 'rotate(180deg)' : '',
        height: '0.75em',
        ...props.sx,
      }}
    >
      <svg viewBox="0 0 20 12" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.2834 0L9.7166 7.417L17.1498 0L19.4332 2.2834L9.7166 12L0 2.2834L2.2834 0Z" />
      </svg>
    </SvgIcon>
  )
}
Chevron.propTypes = {
  up: PropTypes.bool,
  sx: PropTypes.object,
}
export function Arrow() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 12 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.115 15.885L4.245 9L11.115 2.115L9 0L0 9L9 18L11.115 15.885Z"
        fill="currentColor"
      />
    </svg>
  )
}

export function Camera() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 10.5V7C17 6.45 16.55 6 16 6H4C3.45 6 3 6.45 3 7V17C3 17.55 3.45 18 4 18H16C16.55 18 17 17.55 17 17V13.5L21 17.5V6.5L17 10.5Z"
        stroke="currentColor"
      />
    </svg>
  )
}

export function RightArrow() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 27 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 7H24.6508M19 1L25 7L19 13"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  )
}

export function ChevronRight() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="currentColor"
        d="m18.75 36-2.15-2.15 9.9-9.9-9.9-9.9 2.15-2.15L30.8 23.95Z"
      />
    </svg>
  )
}

export function Warning() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
      />
    </svg>
  )
}
export function Info() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
      />
    </svg>
  )
}
export function Remove() {
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path fill="currentColor" d="M19 13H5v-2h14v2z" />
    </SvgIcon>
  )
}
export function Clear() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path
        fill="currentColor"
        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
      />
    </svg>
  )
}
export function FullScreen() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="white"
      width="100%"
      height="100%"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z" />
    </svg>
  )
}
export function FullScreenExit() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="white"
      width="100%"
      height="100%"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z" />
    </svg>
  )
}
export function LiveChat() {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.39246 16.0438L3.3924 16.0438C3.16361 16.0913 2.93406 16.1349 2.70387 16.1744L2.70294 16.1746C2.49997 16.2086 2.32585 16.1114 2.22788 15.9736C2.1311 15.8375 2.09771 15.6496 2.16946 15.4723C2.25142 15.2696 2.3266 15.0639 2.39486 14.8557L2.39642 14.8502L2.39909 14.8409L2.39926 14.841C2.61981 14.1696 2.80043 13.405 2.87655 12.6882C1.71278 11.4265 1.00781 9.78923 1.00781 8C1.00781 3.9761 4.55638 0.75 8.88695 0.75C13.2175 0.75 16.7661 3.9761 16.7661 8C16.7661 12.0238 13.2177 15.2498 8.8873 15.25C8.88719 15.25 8.88707 15.25 8.88695 15.25V15C8.13133 15.0011 7.37885 14.8982 6.64875 14.694L3.39246 16.0438ZM3.39246 16.0438C5.06475 15.6957 6.12999 15.2409 6.67732 14.961L3.39246 16.0438ZM3.99292 11.7218L3.99283 11.7217C3.02157 10.7004 2.46145 9.39878 2.46145 8C2.46145 4.96449 5.19509 2.25 8.88695 2.25C12.5788 2.25 15.3124 4.96449 15.3124 8C15.3124 11.0365 12.5788 13.75 8.88695 13.75H8.88654C8.23696 13.7511 7.58997 13.6628 6.9621 13.4872C6.67314 13.4063 6.36602 13.4402 6.10045 13.5812C5.78774 13.7473 5.12401 14.0564 4.05634 14.3468C4.18697 13.8124 4.27985 13.2686 4.33415 12.7196L4.33416 12.7196L4.33433 12.7177C4.35086 12.5365 4.32911 12.3535 4.27038 12.1816C4.21164 12.0097 4.11716 11.8526 3.99292 11.7218Z"
        fill="#001249"
        stroke="#001249"
        strokeWidth="0.5"
      />
    </svg>
  )
}
export function Play() {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <filter id="shadow">
          <feDropShadow dx="0" dy="1" stdDeviation="0.01" />
        </filter>
      </defs>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        filter="url(#shadow)"
        d="M9 4.5C9 6.98528 6.98528 9 4.5 9C2.01472 9 0 6.98528 0 4.5C0 2.01472 2.01472 0 4.5 0C6.98528 0 9 2.01472 9 4.5ZM6.49003 3.69502L4.00249 2.45125C3.40408 2.15204 2.7 2.58719 2.7 3.25623V5.74377C2.7 6.41281 3.40408 6.84796 4.00249 6.54875L6.49003 5.30498C7.15337 4.97331 7.15337 4.02669 6.49003 3.69502Z"
        fill="currentColor"
      />
    </svg>
  )
}
